import { ChakraImage, ChakraBox as Box } from "@airhelp/react-ui-components";
import { ReviewCard } from "modules/common/components";
import { boxStyles, imageStyles } from "./TrustpilotTestimonialDesktop.styles";
import type { TrustpilotTestimonialDesktopProps } from "./TrustpilotTestimonialDesktop.d";

export const TrustpilotTestimonialDesktop = ({
  cardPosition,
  imageProps,
  review,
  sbEditable,
}: TrustpilotTestimonialDesktopProps) => {
  const positionStyles = { transform: `translate(${cardPosition === "left" ? "-10%" : "35%"}, -50%)` };
  return (
    <Box pos="relative" {...sbEditable}>
      <ChakraImage {...imageProps} {...imageStyles} />
      <Box {...boxStyles} {...positionStyles}>
        <ReviewCard review={review} />
      </Box>
    </Box>
  );
};
